module.exports = __webpack_public_path__ + "static/video-placeholder-3ec17e3a9c2cc6138347cb0a7564f286.jpg";